import { render, staticRenderFns } from "./SlaughterPieChartReport.vue?vue&type=template&id=629e28aa&scoped=true&"
import script from "./SlaughterPieChartReport.vue?vue&type=script&lang=js&"
export * from "./SlaughterPieChartReport.vue?vue&type=script&lang=js&"
import style0 from "./SlaughterPieChartReport.vue?vue&type=style&index=0&id=629e28aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629e28aa",
  null
  
)

export default component.exports